export default {
  index: {
    text1: "초대",
    text2: "자산",
    text3: "계산서",
    text4: "전용 구역",
    text5: "1성 규약",
    text6: "구독",
    text7: "2성 규약",
    text8: "소개",
    text9: "우리 커뮤니티에 가입하세요",
    text10: "상급 계정 연결",
    text11: "추천인 주소를 입력하세요",
    text12: "확인",
    text13: "공헌激励池",
    text14: "남은 보상",
    text15: "오픈 예정",
	text16: "협력 파트너",
  },
  wallet: {
    text1: "총 자산 가치",
    text2: "계산서",
    text3: "잔액",
    text4: "출금",
    text5: "화이트리스트 혜택",
    text6: "IDO 혜택",
    text7: "구독",
 text8: "兑换",
 
 },
 dui :{
 	text1: "兑换白名单权益",
 
 },
  pawn: {
    text1: "수익은 다음 날 18:18 에 정산됩니다. 일일 수익의 70%는 USDT로, 30%는 해당하는 UES 토큰으로 정산됩니다. UES 시장 가치는 3U입니다.",
    text2: "구독",
    text3: "개",
    text4: "1성 규약",
    text5: "일일 수익",
    text6: "2성 규약",
    text7: "3성 규약",
    text8: "Plus 규약"
  },
  zy: {
    text1: "수익 중",
    text2: "만료됨",
    text3: "수량",
    text5: "수익 받음",
    text4: "구독 날짜"
  },
  team: {
    text1: "현재 등급",
    text2: "내 구독",
    text3: "소구역业績",
    text4: "내 추천인",
    text5: "추천인의 구독",
    text6: "내 팀",
    text7: "业績 총합",
    text8: "소구역业績",
    text9: "팀 인원수",
    text10: "내 추천",
    text11: "구독 수량",
    text12: "초대 링크"
  },
  withdrawal: {
    text1: "출금 수량",
    text2: "입금",
    text3: "수수료",
    text4: "지갑 잔액",
    text5: "출금冻结",
    text6: "확인",
    text7: "출금 수량을 입력하세요"
  },
  record: {
    text1: "유형",
    text2: "수량",
    text3: "시간"
  },
  header: {
    text1: '더보기',
    text2: "추천 링크",
    text3: "홈",
    text4: "지갑",
    text5: "구독",
    text6: "내 규약",
    text7: "내 팀",
	text8: 'RLP白名单',
  },
  lan: {
    text1: '영어',
    text2: '간체 중국어',
    text3: '번체 중국어',
    text4: '태국어',
    text5: '한국어',
    text6: '일본어',
    text7: '베트남어'
  },
  tost: {
    text1: '오픈 예정',
    text2: '출금 수량을 입력하세요',
    text3: '잔액이 부족합니다',
    text4: '복사 성공',
	text5: '최소 50 USDT 이상 이체하세요',
  },
  rlp: {
  	 text10: "RLP 구매 신청",
  	    text1: "화이트리스트 100 할당량으로 0.1BNB 구매 가능",
  	    text2: "구매 신청",
  	    text4: "구매 가격",
  	    text3: "100 할당량/0.1BNB",
  	    text5: "BNB",
  	    text6: "내 화이트리스트",
  	    text7: "구매 신청"
  	
  },
  aitoken: {
    brand: 'GMI 클라우드',
    connectWallet: '지갑 연결',
    language: '언어',
    tabs: {
      home: '홈',
      business: '비즈니스',
      orders: '주문',
      referral: '추천',
    },
  },
}
